import React, {useImperativeHandle, useState, useRef, forwardRef, useContext, useEffect} from "react";

import {View, Text}  from 'react-native';

import {estilos} from '../util/estilos'

import Botao from '../componentes/Botao'

import * as util from '../util/util'

import {buscarPedidos, excluirPedido as wsExcluirPedido} from '../ws/ws_pedidos'

import FormularioPesquisa from '../componentes/FormularioPesquisa'

import contexto from '../util/contexto'

import cores from '../util/cores'

import {PEDIDO_SITUACAO_ATIVO, PEDIDO_SITUACAO_CANCELADO, PEDIDO_SITUACAO_CONCLUIDO, 
	TELA_BUSCAR_PEDIDOS, TELA_DETALHE_PEDIDO, TELA_NOVO_PEDIDO,
	TELA_PROPOSTAS_MEU_PEDIDO} from '../util/constantes'

import * as data from '../util/data'

import {useNavigation} from '@react-navigation/native'

import Bloco from '../componentes/Bloco'

import Imagem from '../componentes/Imagem'

import Combo from '../componentes/Combo'

import Alerta from '../componentes/Alerta'


export const TIPO_GESTAO_PEDIDO = 7;
export const TIPO_BUSCAR_PEDIDO = 17;



const FormularioBuscarPedido = forwardRef((props, ref) => {

	const {valorContexto, setValorContexto} = useContext(contexto);

	const navegacao = new useNavigation();

	const [filtroSituacao, setFiltroSituacao] = useState(PEDIDO_SITUACAO_ATIVO)
	
	const formularioPesquisaRef  = useRef(null)

	
	useImperativeHandle(ref, () => ({}));


	const buscarDados= async (termos)=>{
	
		let itens  = props.tipo == TIPO_GESTAO_PEDIDO?
					await buscarPedidos(valorContexto.idUsuarioAtual, filtroSituacao, termos, formularioPesquisaRef.current.getIndex()):
						await buscarPedidos(null, PEDIDO_SITUACAO_ATIVO, termos, formularioPesquisaRef.current.getIndex());
	
		return util.temConteudo(itens)?itens:[];
	}


	useEffect(() => {
		
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.pesquisar();
		
	}, []); 
	
	
	const verPedido= async (id_pedido)=>{

		console.log("verPedido id_pedido="+id_pedido);
		
		setValorContexto(prevState =>({...prevState, idPedido: id_pedido}));

		util.setVoltar(props.voltarPara);

		navegacao.navigate(TELA_DETALHE_PEDIDO)
	}
	

	const novoPedido= async ()=>{

		console.log("novoPedido");
		
		setValorContexto(prevState =>({...prevState, idPedido: null}));
		
		util.setVoltar(props.voltarPara);

		navegacao.navigate(TELA_NOVO_PEDIDO)
	}

	
	const verPropostas= async (id_pedido)=>{

		console.log("verPropostas id_pedido="+id_pedido);
		
		setValorContexto(prevState =>({...prevState, idPedido: null}));
		
		util.setVoltar(props.voltarPara);

		navegacao.navigate(TELA_PROPOSTAS_MEU_PEDIDO)
	}


	const preparaParaRemover= async (id_pedido)=>{

		console.log("preparaParaRemover "+id_pedido);
		
		Alerta("Exclusão de Pedido", "Deseja realmente excluir este pedido?", async() => removerPedido(id_pedido));
	}


	const removerPedido= async (id_pedido)=>{

		console.log("removerPedido "+id_pedido);
			
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.sincronizando();
		
		await wsExcluirPedido(id_pedido);
			
		if(formularioPesquisaRef.current!=null)
			formularioPesquisaRef.current.pesquisar();
	}
	
	
	function filtrosPesquisa(){
		
		if(props.tipo == TIPO_GESTAO_PEDIDO){
			
			let dados = [{'id': PEDIDO_SITUACAO_ATIVO, 'nome': "Ativos"}, 
						{'id': PEDIDO_SITUACAO_CONCLUIDO, 'nome': "Concluídos"},
						{'id': PEDIDO_SITUACAO_CANCELADO, 'nome': "Cancelados"}];
			
			return(
				<View>  	
					<View style={{marginTop:10}}/>
					<View style={estilos.grade}>
						<View style={estilos.coluna_dupla}> 
							<Combo 
								mostrarVazio = {false}
								rotulo="Situação:"
								dados={dados} 
								aoMudar={(valor)=>setFiltroSituacao(valor.id)}
								selecionado={filtroSituacao}/>
						</View>
						<View style={estilos.coluna}/> 
					</View> 
					<View style={{marginTop:10}}/> 
				</View>
			)
		}
			
		return (<View></View>)
	}
	
	
	function getOpcoesItem(item){
		
		if(props.tipo == TIPO_GESTAO_PEDIDO)
			return(
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Botao
							acao={()=>{
								
								verPedido(item.id)
							}}
							texto="detalhar"
							somente_texto={true}
							cor={cores.azul}/> 
					</View>
					
					<View style={[estilos.coluna, {alignItems:'center'}]}>
						<Botao
							acao={()=>verPropostas(item.id)}
							texto="Propostas"
							somente_texto={true}
							cor={cores.azul}/> 
					</View>
					
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
						{item.situacao == PEDIDO_SITUACAO_ATIVO && 
							<Botao
								acao={()=>preparaParaRemover(item.id)}
								texto="Cancelar"
								somente_texto={true}
								cor={cores.vermelho}/>
						}								
					</View>
				</View>		
			)
		
		if(props.tipo == TIPO_BUSCAR_PEDIDO)	
			return(
				<View style={{alignItems:'flex-end'}}>
					<Botao
						acao={()=>{
								
							util.setVoltar(TELA_BUSCAR_PEDIDOS);

							verPedido(item.id)
						}}
						texto="detalhar"
						somente_texto={true}
						cor={cores.azul}/> 
				</View>
			)
		
		return (<View></View>)
	}
	
	
	return (
		<View style={{flex:1}}> 
			<FormularioPesquisa 
				ref={formularioPesquisaRef} 
				pesquisar={buscarDados} 
				componentes={filtrosPesquisa()}
				msgSemDados={TIPO_GESTAO_PEDIDO?
								"Nenhum pedido de orçamento cadastrado.":
									"Nenhum pedido encontrado"}
				itemLista={(item)=>itemLista(item)}>
						
				{props.tipo == TIPO_GESTAO_PEDIDO && 
					(props.podeCriar==0?
						<View/>:
						(props.podeCriar>0?
							<View style={{alignItems:'center'}}>
								<Botao 
									acao={()=>novoPedido()}
									texto="Novo Pedido de Orçamento"/>   
								<View style={{marginTop:10}}/>
							</View>:
							<View style={{alignItems:'center'}}>
								<View style={{marginTop:10}}/>
								<Text style={[estilos.rotulo_titulo, {color:cores.fonte_clara}]}>Seu endereço de e-mail ainda nao foi verificado.</Text>
								<View style={{marginTop:5}}/>
								<Text style={[estilos.rotulo_menor, {color:cores.fonte_clara}]}>Você não poderá cadastrar pedidos até realizar a verificação.</Text>
								<View style={{marginTop:5}}/>
								<Text style={[estilos.rotulo_menor, {color:cores.fonte_clara}]}>Acesse a opção "Meus Dados" e confirme seu e-mail.</Text>
								<View style={{marginTop:10}}/>
							</View>
						)
					)	
				}
			</FormularioPesquisa>
		</View>
		
	); 


	function itemLista(item){

		return (
			<Bloco> 
				<View style={{marginTop:5}}/>
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Text style={estilos.rotulo_menor}>Expiração: {data.converteDataEuaParaBr(item.data_expiracao, true)}</Text>
					</View>
				</View>
				
				<View style={estilos.grade}>
					<View> 
						<Imagem imagem={item.imagem} tamanho={80} redondo={true}/>
					</View> 
					<View style={estilos.coluna}> 
						<Text style={estilos.rotulo_titulo}>{item.titulo}</Text>
						<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 100)}</Text>
					</View> 
				</View> 	
						
				<View style={{marginTop:20}}/>
				{getOpcoesItem(item)}
				<View style={{marginTop:5}}/>
			</Bloco>)
	}

});


export default FormularioBuscarPedido;
